module.exports = __webpack_public_path__ + "static/tsn-hero-50ed354032c3f7e704e454085f73047f.webm";